import { lazy } from 'react'
import { Navigate } from 'react-router-dom'


const CardReconciliation = lazy(() => import('src/pages/members/Pos/CardReconciliation/CardReconciliation'))
const ThirdPartyReconciliation = lazy(() => import('src/pages/members/Pos/ThirdPartyReconciliation'))
const ThirdPartyOrdersReconciliation = lazy(() => import('src/pages/members/Pos/ThirdPartyOrdersReconciliation'))
// Order Based Paying
const FinancePayouts = lazy(() => import('src/pages/members/Finance/Finance'))
const BankReconciliation = lazy(() => import('src/pages/members/Finance/SubPages/BankReconciliation'))
const ListOfPayouts = lazy(() => import('src/pages/members/Finance/SubPages/ListOfPayouts'))
const OrderBasedPaying = lazy(() => import('src/pages/members/OrderBasedPaying/OrderBasedPaying'))
const OrdersAndTransactions = lazy(() => import('src/pages/members/OrdersAndTransactions/OrdersAndTransactions'))

const AccountingPortal = lazy(() => import('src/pages/members/AccountingPortal/AccountingPortal'))

const OloTransactions = lazy(() => import('src/pages/members/OloTransactions/OloTransactions'))

const OloCustomers = lazy(() => import('src/pages/members/OloCustomers/OloCustomers'))

const OloItems = lazy(() => import('src/pages/members/OloItems/OloItems'))

const BankAccounts = lazy(() => import('src/pages/members/OrderBasedPaying/components/BankAccountMappings/BankAccountMappings'))

const JESettings = lazy(() => import('src/pages/members/BookkeepingSetup/JESettings'))

const BookkeepingSetupConfigureChartOfAccounts = lazy(() => import('src/pages/members/BookkeepingSetup/ConfigureChartOfAccounts'))
const BookkeepingSetupSelectLocationsAndVariables = lazy(() => import('src/pages/members/BookkeepingSetup/SelectLocationsAndVariables'))
const BookkeepingSetupReviewSetup = lazy(() => import('src/pages/members/BookkeepingSetup/ReviewSetup'))
const TransactionsByStore = lazy(() => import('src/pages/members/TransactionsByStore/TransactionsByStore'))

const AccountingCadence = lazy(() => import('src/pages/members/BookkeepingSetup/AccountingCadence'))

const AddAccountingCadence = lazy(() => import('src/pages/members/AccountingSetup/AddAccountingCadence'))

const AccountingTemplate = lazy(() => import('src/pages/members/AccountingSetup/AccountingTemplate'))

const AccountingHistory = lazy(() => import('src/pages/members/AccountingSetup/AccountingHistory'))
const AccountingLocationPushHistory = lazy(() => import('src/pages/members/AccountingLocationPushHistory/AccountingLocationPushHistory'))

const CrunchtimeConfiguration = lazy(() => import('src/pages/members/Crunchtime/CrunchtimeConfiguration'))
const PosReport = lazy(() => import('src/pages/members/Pos/PosReport/PosReport'))
const PosSettings = lazy(() => import('src/pages/members/Pos/PosSettings'))

const AccountingLocationStatus = lazy(() => import('src/pages/members/AccountingSetup/AccountingLocationStatus'))
const AccountingSetup = lazy(() => import('src/pages/members/AccountingSetup/AccountingSetup'))

const AddAccountingSoftware = lazy(() => import('src/pages/members/AccountingSetup/AddAccountingSoftware'))

const ValidateJournalEntries = lazy(() => import('src/pages/members/ValidateJournalEntries/ValidateJournalEntries'))

const RoyaltyOverview = lazy(() => import('src/pages/members/Royalty/RoyaltyOverview'))

const TaxOverview = lazy(() => import('src/pages/members/Tax/TaxOverview'))

const TaxByStore = lazy(() => import('src/pages/members/Tax/TaxByStore'))

const TaxGuide = lazy(() => import('src/pages/members/Tax/TaxGuide'))
const PosTaxConfig = lazy(() => import('src/pages/members/Tax/PosTaxConfig'))
const POSVariances = lazy(() => import('src/pages/members/Pos/POSVariances/POSVariances'))
const AddPosIntegration = lazy(() => import('src/pages/members/Pos/PosIntegrations/AddPosIntegration/AddPosIntegration'))
const PosIntegrations = lazy(() => import('src/pages/members/Pos/PosIntegrations/PosIntegrations'))
const PosLocationsMappings = lazy(() => import('src/pages/members/Pos/PosIntegrations/PosLocations/PosLocationsMappings'))
const PosIntegrationUpload = lazy(() => import('src/pages/members/Pos/PosIntegrations/PosIntegrationUpload/PosIntegrationUpload'))
const PosReviewSetup = lazy(() => import('src/pages/members/Pos/PosIntegrations/PosReviewSetup/PosReviewSetup'))

const ProfitMarginCalculatorV2 = lazy(() => import('src/pages/members/Finance/ProfitMarginCalculatorV2'))

const BankSettings = lazy(() => import('src/pages/members/Bank/BankSettings'))

const MarketingCOGS = lazy(() => import('src/pages/members/MarketingNew/Cogs'))

export const existingRoutes = [
  // Legacy route redirects - automatically redirect to new /balance/* paths
  // Kept for backwards compatibility with user bookmarks
  {
    path: 'order/based/payouts',
    element: (
      <Navigate
        to="/balance/transactions-and-payouts/reports"
        replace
      />
    )
  }, // 93 pageviews, 33 users → redirects to /balance/transactions-and-payouts/reports
  {
    path: 'reconciliation/bank_reconciliation',
    element: (
      <Navigate
        to="/balance/reconciliation/bank"
        replace
      />
    )
  }, // 10 pageviews, 9 users → redirects to /balance/reconciliation/bank
  {
    path: 'order/based/overview',
    element: (
      <Navigate
        to="/balance/income-statement"
        replace
      />
    )
  }, // 426 pageviews, 9 users (sam@getmyfixe.com: 231 visits!) → redirects to /balance/income-statement
  {
    path: 'order/based/plaid/accounts',
    element: (
      <Navigate
        to="/balance/plaid-accounts"
        replace
      />
    )
  }, // 5 pageviews, 5 users → redirects to /balance/plaid-accounts
  {
    path: 'order/based/accounting-portal',
    element: (
      <Navigate
        to="/balance/journal-entries/"
        replace
      />
    )
  } // 111 pageviews, 3 users (jada@getmyfixe.com: 104 visits!) → redirects to /balance/journal-entries/
]

export const moduleNamedRoutes = [
  {
    path: 'balance',
    children: [
      {
        index: true,
        element: (
          <Navigate
            to="income-statement"
            replace
          />
        )
      },
      { path: 'income-statement', element: <FinancePayouts /> },
      {
        path: 'transactions-and-payouts',
        children: [
          {
            index: true,
            element: (
              <Navigate
                to="transactions"
                replace
              />
            )
          },
          { path: 'transactions', element: <OrdersAndTransactions /> },
          { path: 'reports', element: <OrderBasedPaying /> },
          { path: 'transactions-by-location', element: <TransactionsByStore /> }
        ]
      },
      {
        path: 'journal-entries',
        children: [
          {
            index: true,
            element: <AccountingPortal />
          },
          {
            path: '/',
            element: <AccountingPortal />
          },
          { path: 'add-bank', element: <BankAccounts /> },
          { path: 'integrations', element: <AccountingSetup /> },
          { path: 'integrations-add', element: <AddAccountingSoftware /> },
          { path: 'cadence', element: <AccountingCadence /> },
          { path: 'cadence-add', element: <AddAccountingCadence /> },
          { path: 'templates', element: <AccountingTemplate /> },
          { path: 'settings', element: <JESettings /> },
          { path: 'select-locations', element: <BookkeepingSetupSelectLocationsAndVariables /> },
          { path: 'configure-chart-of-accounts', element: <BookkeepingSetupConfigureChartOfAccounts /> },
          { path: 'review-setup', element: <BookkeepingSetupReviewSetup /> },
          { path: 'history', element: <AccountingHistory /> },
          { path: 'push-summary', element: <AccountingLocationPushHistory /> },
          { path: 'history-internal', element: <AccountingHistory /> },
          { path: 'location-status', element: <AccountingLocationStatus /> },
          { path: 'integrations-add', element: <AddAccountingSoftware /> },
          { path: 'validate', element: <ValidateJournalEntries /> }
        ]
      },

      { path: 'payouts-list', element: <ListOfPayouts /> },
      { path: 'by-store', element: <OrderBasedPaying tab="by_store" /> },
      { path: 'bank-reconciliation', element: <OrderBasedPaying tab="bank_reconciliation" /> },
      { path: 'by-store', element: <BankReconciliation /> },

      { path: 'reports', element: <OrderBasedPaying /> },
      { path: 'transactions-non-variance-zero', element: <OrdersAndTransactions show_only_non_variance_zero /> },

      { path: 'accounting-portal/:tab', element: <AccountingPortal /> },
      {
        path: 'accounting-portal',
        element: (
          <Navigate
            to="/balance/journal-entries"
            replace
          />
        )
      },
      { path: 'codat-link', element: <AccountingPortal /> },
      { path: 'olo-transactions', element: <OloTransactions /> },
      { path: 'olo-customers', element: <OloCustomers /> },
      { path: 'olo-items', element: <OloItems /> },
      { path: 'plaid-accounts', element: <BankAccounts /> },

      { path: 'accounting-setup', element: <AccountingSetup /> },
      {
        path: 'reconciliation',
        children: [
          {
            path: 'bank',
            element: <OrderBasedPaying tab="bank_reconciliation" />
          },
          {
            path: 'payout',
            element: <OrdersAndTransactions show_only_non_variance_zero />
          }
        ]
      },

      {
        path: 'pos-reconciliation',
        children: [
          {
            path: 'reports',
            element: <PosReport />
          },
          {
            path: 'third-party',
            element: <ThirdPartyReconciliation />
          },
          {
            path: 'crunchtime-configuration',
            element: <CrunchtimeConfiguration />
          },
          {
            path: 'variances',
            element: <POSVariances />
          }
        ]
      },
      { path: 'royalty-overview', element: <RoyaltyOverview /> },
      {
        path: 'tax',
        children: [
          {
            index: true,
            element: (
              <Navigate
                to="overview"
                replace
              />
            )
          },
          {
            path: 'overview',
            element: <TaxOverview />
          },
          { path: 'by-store', element: <TaxByStore /> },
          {
            path: 'guide',
            element: <TaxGuide />
          },
          {
            path: 'pos-config',
            element: <PosTaxConfig />
          }
        ]
      },
      {
        path: 'pos',
        children: [
          {
            index: true,
            element: (
              <Navigate
                to="integrations"
                replace
              />
            )
          },
          {
            path: 'integrations',
            element: <PosIntegrations />
          },
          {
            path: 'integrations/add',
            element: <AddPosIntegration />
          },
          {
            path: 'locations',
            element: <PosLocationsMappings />
          },
          {
            path: 'upload',
            element: <PosIntegrationUpload />
          },
          {
            path: 'review-setup',
            element: <PosReviewSetup />
          },
          {
            path: 'settings',
            element: <PosSettings />
          },
          {
            path: 'variances',
            element: <POSVariances />
          },
          {
            path: 'third-party-reconciliation',
            element: <ThirdPartyReconciliation />
          },
          {
            path: 'third-party-orders-reconciliation',
            element: <ThirdPartyOrdersReconciliation />
          },
          {
            path: 'crunchtime-configuration',
            element: <CrunchtimeConfiguration />
          },
          {
            path: 'card-reconciliation',
            element: <CardReconciliation />
          }
        ]
      },
      {
        path: 'bank',
        children: [
          {
            index: true,
            element: (
              <Navigate
                to="settings"
                replace
              />
            )
          },
          {
            path: 'settings',
            element: <BankSettings />
          }
        ]
      },
      { path: 'margin-analysis', element: <ProfitMarginCalculatorV2 /> },
      { path: 'cogs', element: <MarketingCOGS /> }
    ]
  }
]

export const balanceRoutes = [...existingRoutes, ...moduleNamedRoutes]
